<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper">
      <div class="left">
        <div class="block">
          <QuoteForm :quote="quote" :loading="loading" @save-quote="handleSaveQuote"></QuoteForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import QuoteForm from './components/forms/quote-form'
export default {
  name: 'NewQuote',
  components: {
    QuoteForm
  },
  data () {
    return {
      quote: {
        currency: 'CNY',
        exchange_rate: 0,
        tax_rate: 0.13,
        type: 'single_product',
        status: 'open'
      },
      loading: false
    }
  },
  computed: {
    pageTitle () {
      document.title = this.$t('menu.quote.new_quote')
      return document.title
    }
  },
  methods: {
    ...mapActions([
      'createQuote'
    ]),
    handleSaveQuote (data) {
      this.loading = true
      this.createQuote(data).then(res => {
        this.$Message.success('Quote has been successfully created!')
        this.$router.push({
          name: 'menu.quote.edit',
          params: {
            quoteId: res.data.id
          }
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
